import { observer } from 'mobx-react-lite'
import { Typography, SpinnerLoader, EnumSpinnerLoaderPosition } from 'shared/ui'
import { useAddOnsViewContext } from 'pages/settings/pages/addOns/context/addOnsViewContext'
import { TrustedCalling } from 'pages/settings/pages/addOns/ui/TrustedCalling/TrustedCalling'
import { BrandedUrlShortener } from 'pages/settings/pages/addOns/ui/BrandedUrlShortener/BrandedUrlShortener'
import { PhoneCheckr } from 'pages/settings/ui/PhoneCheckr'
import styles from './styles.module.scss'

export const AddOnsView = observer(() => {
  const store = useAddOnsViewContext()

  return (
    <div className={styles.content}>
      {store.loading && (
        <>
          <div className={styles.loaderWrapper} />
          <SpinnerLoader
            ariaLabel='AddOnsView'
            position={EnumSpinnerLoaderPosition.Absolute}
            size={32}
          />
        </>
      )}
      <div className={styles.addOnsHeader}>
        <Typography variant='heading-lg' ariaLabel='Add-ons title'>
          Add-ons
        </Typography>
        <Typography
          variant='body-md-regular'
          ariaLabel='Add-ons desc'
          color='var(--content-primary-tertiary)'
        >
          Supercharge your plan with premium features
        </Typography>
      </div>

      <div className={styles.addOnsContent}>
        <PhoneCheckr />
        <TrustedCalling />
        <BrandedUrlShortener />
      </div>
    </div>
  )
})
